import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav/Nav';

function CGV() {
  return (
    <div>
      <Nav />
      <div className='wrapper-container legal-container'>
        <div className='wrapper-content'>

          <div className='title-wrapper'>
            <h2>Conditions Générales de Vente</h2>
          </div>

          <p>
            Les présentes Conditions Générales de Vente (CGV) encadrent les achats réalisés sur la plateforme Fastline.
          </p>

          <br />

          <h2><strong>1. Rôle de Fastline</strong></h2>
          <p>
            Fastline est une plateforme permettant à des vendeurs (commerçants, restaurateurs ou prestataires)
            de proposer leurs produits ou services en ligne.
          </p>
          <p>
            Fastline agit uniquement en tant qu’intermédiaire technique.
          </p>
          <p>
            Le contrat de vente est conclu directement entre le client et le vendeur.
          </p>

          <br />

          <h2><strong>2. Produits et services</strong></h2>
          <p>
            Les produits et services sont proposés par des vendeurs indépendants.
          </p>
          <p>
            Chaque vendeur est seul responsable :
          </p>
          <ul>
            <li>des descriptions</li>
            <li>des prix</li>
            <li>de la disponibilité</li>
            <li>de l’exécution des commandes</li>
          </ul>

          <br />

          <h2><strong>3. Commandes</strong></h2>
          <p>
            Toute commande passée sur la plateforme constitue un engagement ferme du client auprès du vendeur.
          </p>
          <p>
            Une fois validée, la commande ne peut être modifiée ou annulée qu’avec l’accord du vendeur.
          </p>

          <br />

          <h2><strong>4. Prix</strong></h2>
          <p>
            Les prix sont fixés librement par les vendeurs.
          </p>
          <p>
            Des frais supplémentaires peuvent s’appliquer (livraison, service), selon le vendeur.
          </p>

          <br />

          <h2><strong>5. Paiement</strong></h2>
          <p>
            Les paiements sont traités de manière sécurisée via Stripe.
          </p>
          <p>
            Fastline agit en tant qu’intermédiaire technique dans le traitement des paiements et peut percevoir une commission.
          </p>

          <br />

          <h2><strong>6. Livraison et exécution</strong></h2>
          <p>
            La préparation, la livraison et l’exécution des commandes sont assurées uniquement par le vendeur.
          </p>
          <p>
            Fastline n’intervient pas dans la livraison ni dans l’exécution des services.
          </p>

          <br />

          <h2><strong>7. Droit de rétractation</strong></h2>
          <p>
            Le droit de rétractation peut ne pas s’appliquer selon la nature des produits ou services,
            notamment pour les produits périssables ou personnalisés.
          </p>
          <p>
            Toute demande doit être adressée directement au vendeur.
          </p>

          <br />

          <h2><strong>8. Remboursements et litiges</strong></h2>
          <p>
            Les remboursements et litiges sont gérés exclusivement par le vendeur.
          </p>
          <p>
            Fastline ne prend aucune décision concernant les remboursements.
          </p>

          <br />

          <h2><strong>9. Responsabilité</strong></h2>
          <p>
            Fastline ne peut être tenu responsable :
          </p>
          <ul>
            <li>de la qualité des produits ou services</li>
            <li>du respect des délais</li>
            <li>de la livraison</li>
            <li>de l’exécution des commandes</li>
          </ul>

          <br />

          <h2><strong>10. Contact</strong></h2>
          <p>
            Pour toute question liée à une commande, le client doit contacter directement le vendeur.
          </p>
          <p>
            Pour toute question technique liée à la plateforme :
            <a href="mailto:contact@fastlineapp.com"> contact@fastlineapp.com</a>
          </p>

          <br />

          <h2><strong>11. Droit applicable</strong></h2>
          <p>
            Les présentes CGV sont soumises au droit français.
          </p>

          <br />

          <h2><strong>Documents associés</strong></h2>
          <ul className="legal-links">
            <li style={{textDecoration:'underline'}}><Link to="/terms-of-service">Conditions d’utilisation</Link></li>
            <li style={{textDecoration:'underline'}}><Link to="/privacy-policy">Politique de confidentialité</Link></li>
            <li style={{textDecoration:'underline'}}><Link to="/legal-notice">Mentions légales</Link></li>
          </ul>

        </div>
      </div>
    </div>
  );
}

export default CGV;